import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ContentConstants from '../contentConstants';
import { ISurveyTemplate } from '../models/ISurveyTemplate';
import * as SurveyAPI from '../services/SurveyAPI';
import { ActionTypes as CommonActionTypes } from './ActionTypes';

export interface ISurveyTemplateState {
	templates: ISurveyTemplate[];
	isLoading: boolean;
}

export const initialState: ISurveyTemplateState = {
	templates: [],
	isLoading: false,
};

export const getSurveyTemplates = createAsyncThunk('SurveyTemplates/getSurveyTemplates', async () => {
	return SurveyAPI.getSurveyTemplates();
});

export const copySurveyTemplate = createAsyncThunk(
	'SurveyTemplates/copySurveyTemplate',
	async ({ surveyId, clientId }: { surveyId: number; clientId: number }, { dispatch }) => {
		try {
			const surveyCopy = await SurveyAPI.copySurveyTemplate(surveyId, clientId);
			dispatch({ type: CommonActionTypes.SURVEY_LIST_CLONE_SURVEY_SUCCEEDED, payload: [surveyCopy] });
			dispatch({ type: CommonActionTypes.TOAST_INFO_NOTIFICATION, payload: ContentConstants.TOAST_BULK_COPY_SURVEYS_FINISHED });
		} catch {
			dispatch({ type: CommonActionTypes.TOAST_WARNING_NOTIFICATION, payload: ContentConstants.TOAST_ERROR_GENERIC_SAVE_BODY });
		}
	},
);

const SurveyTemplateSlice = createSlice({
	name: 'SurveyTemplates',
	initialState: initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getSurveyTemplates.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(getSurveyTemplates.fulfilled, (state, action) => {
				state.isLoading = false;
				state.templates = action.payload;
			})
			.addCase(getSurveyTemplates.rejected, (state) => {
				state.isLoading = false;
			});
	},
});

export default SurveyTemplateSlice.reducer;
